import { render, staticRenderFns } from "./training-program.vue?vue&type=template&id=6978b814&scoped=true"
import script from "./training-program.vue?vue&type=script&lang=js"
export * from "./training-program.vue?vue&type=script&lang=js"
import style0 from "./training-program.vue?vue&type=style&index=0&id=6978b814&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6978b814",
  null
  
)

export default component.exports